export default "<div class=\"fill-wh\">\n  <app-nav></app-nav>\n  <router-outlet></router-outlet>\n</div>\n"